export enum TransferIntent {
  captureSignature = 'Capture Signature',
  resumeApplication = 'Resume Application',
  transferApplication = 'Transfer Application',
}
